import * as XLSX from "xlsx";

/**
 * Parse Excel cell value to Date (serial number or string).
 */
export const parseExcelDatetime = (value) => {
    if (value === undefined || value === null || value === "") return null;

    if (typeof value === "number") {
        const parsed = XLSX.SSF.parse_date_code(value);
        if (!parsed) return null;
        return new Date(parsed.y, parsed.m - 1, parsed.d, parsed.H || 0, parsed.M || 0, parsed.S || 0);
    }

    const d = new Date(value);
    return Number.isNaN(d.getTime()) ? null : d;
};
